"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _ClientAppDataConfig = require("./ClientAppDataConfig");
Object.keys(_ClientAppDataConfig).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _ClientAppDataConfig[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _ClientAppDataConfig[key];
        }
    });
});
var _parseClientAppConfig = require("./parseClientAppConfig");
Object.keys(_parseClientAppConfig).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _parseClientAppConfig[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _parseClientAppConfig[key];
        }
    });
}); //# sourceMappingURL=index.js.map
